import { marqueeFeed } from '@/mocks/home';

export default function MarqueeFeed() {
  const feed = [...marqueeFeed, ...marqueeFeed];

  return (
    <section className="w-full border-y border-background-200 bg-background-100 py-3">
      <div className="flex w-full items-center gap-3 overflow-hidden">
        <span className="ml-4 flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 md:ml-6">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-flashlight-line text-xs" />
          </span>
          新瓜速递
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track">
            {feed.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex shrink-0 items-center gap-2 whitespace-nowrap px-5 text-xs text-foreground-700"
              >
                <span className="h-1 w-1 rounded-full bg-accent-500" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}